/* Сперва это, потом thetop, чтобы правильно считалась высота */
var cat = function(el){
	var box = document.getElementById('illumination');

	if(box && !box.getBoundingClientRect().width){
		var mainLeft = document.getElementById('main-left');
		var box = document.createElement('DIV');

		box.className = 'cat layer layer-light';
		box.innerHTML =
				'<div class="grid">'+
					'<img class="cat_image" src="/static/img/bg/cat.png" alt="Грустный котик" />'+
					'<div class="cat_content">'+
						'<span class="cat_title title2">Редакционный котик грустит</span>'+
						'<p class="cat_desc">'+
							'<span class="cat_desc_att">Включенный блокировщик рекламы</span> Включенный блокировщик рекламы делает его работу менее прибыльной, а значит и сам сайт становится менее интересным. Мы не используем огромные попапы и всякие мешающие посетителям форматы рекламы. Пожалуйста, добавьте нас в белый список блокировщика.'+
						'</p>'+
					'</div>'+
				'</div>';

		mainLeft.insertBefore(box, mainLeft.firstChild);
	}
}

export {cat};
